module.exports = __webpack_public_path__ + "img/send.e7a7b0f6.svg";